import {Rule} from './types';

export const required =
    <T>(message: string): Rule<T> =>
    value => {
        if (typeof value === 'string') {
            if (!value.trim().length) {
                return message;
            }
        } else {
            if (!value) {
                return message;
            }
        }

        return undefined;
    };

export const regex =
    <T extends string>(regex: RegExp, message: string): Rule<T> =>
    value => {
        if (!regex.test(value)) {
            return message;
        }

        return undefined;
    };

export const email = <T extends string>(message: string): Rule<T> => regex(/.+@.+\..+/i, message);

export const min =
    <T extends string | number | any[]>(number: number, message: string): Rule<T> =>
    value => {
        if (typeof value === 'number') {
            if (value < number) {
                return message;
            }
        } else {
            if (value.length < number) {
                return message;
            }
        }

        return undefined;
    };

export const max =
    <T extends string | number | any[]>(number: number, message: string): Rule<T> =>
    value => {
        if (typeof value === 'number') {
            if (value >= number) {
                return message;
            }
        } else {
            if (value.length >= number) {
                return message;
            }
        }

        return undefined;
    };
